module.exports = __webpack_public_path__ + "img/denver-dig.0bedb8c.png";